import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import PropTypes from 'prop-types';
import Star from '../../legacyCore/icons/Star';
import { REVIEW_SERVICE_TYPE } from '../constants';
import ReviewServiceLogo from './ReviewServiceLogo';
import StarRating from './StarRating';
import style from './RatingStats.scss';

const HAS_PERCENTAGE_RATINGS = [REVIEW_SERVICE_TYPE.LOCALMED];

const RatingStats = ({ rating, reviewCount, serviceType }) => {
  const hasPercentageRating = HAS_PERCENTAGE_RATINGS.includes(serviceType);
  let ratingValue = rating;
  let ratingFormatOptions = { style: 'decimal', maximumFractionDigits: 1 };
  if (hasPercentageRating) {
    ratingValue = rating / 100;
    ratingFormatOptions = { style: 'percent', maximumFractionDigits: 0 };
  }
  return (
    <div className={style['rating-stats']}>
      <ReviewServiceLogo className={style['rating-stats__logo']} serviceType={serviceType} />
      <div className={style['rating-stats__details']}>
        <div className={style['rating-stats__value']}>
          <FormattedNumber value={ratingValue} {...ratingFormatOptions} />
        </div>
        {!hasPercentageRating && (
          <span className={style['rating-stats__star-icon']}>
            <Star verticalAlign="center" />
          </span>
        )}
        {!hasPercentageRating && (
          <StarRating className={style['rating-stats__star-rating']} rating={rating} />
        )}
        <div className={style['rating-stats__count']}>
          <FormattedMessage
            id="RatingStats.reviewCount"
            defaultMessage="{reviewCount, plural, one {# review} other {# reviews}}"
            values={{ reviewCount }}
          />
        </div>
      </div>
    </div>
  );
};

RatingStats.propTypes = {
  rating: PropTypes.number.isRequired,
  reviewCount: PropTypes.number.isRequired,
  serviceType: PropTypes.string.isRequired,
};

export default RatingStats;
